import { Box, Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import GlobalGlobe from "@/components/globe/GlobalGlobe";
import type { GuestNetworkRegionStat } from "../../hooks/useGuestNetworkStats";
import {
  GUEST_NETWORK_STATS_EMPTY,
  GUEST_NETWORK_STATS_UNAVAILABLE,
} from "../../hooks/useGuestNetworkStats";

type DiscoverHeroGeographyDonutProps = {
  segments: GuestNetworkRegionStat[];
  loadError?: boolean;
};

export default function DiscoverHeroGeographyDonut({
  segments,
  loadError = false,
}: DiscoverHeroGeographyDonutProps) {
  const reducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)", false, {
    getInitialValueInEffect: true,
  });
  const visibleSegments = segments.filter((segment) => segment.count > 0 && segment.percent > 0);

  if (!visibleSegments.length) {
    return (
      <Text size="sm" c="dimmed" py="md" ta="center">
        {loadError ? GUEST_NETWORK_STATS_UNAVAILABLE : GUEST_NETWORK_STATS_EMPTY}
      </Text>
    );
  }

  return (
    <Box h="100%" mih={0} style={{ flex: 1 }}>
      <GlobalGlobe reducedMotion={Boolean(reducedMotion)} regions={visibleSegments} />
    </Box>
  );
}
